import { Table, TableBody } from '@mui/material'
import SearchInPageInput from '../../../components/SearchInPage';
import { SectionHeader, SectionWrapper, Row } from '../../../components/tableComponents';
import { ISnapshot } from '../../../types/snapshot'

type props = {
    snapshot: ISnapshot
}

const GeneralDetailsTable = ({snapshot} : props) => {
    return (
        <Table  aria-label="overview snapshot table">
            <SectionHeader title="Overview" />
            <TableBody>
                <Row field='Name' value={`${snapshot.name}`}/>
                <Row field='Address' hasCopyOption route={`/snapshots/${snapshot.address}`} value={snapshot.address}/>
                <Row field='Is Main' value={snapshot.isMain? "True" : "False"}/>
            </TableBody>
        </Table>
    );
}

const SnapshotOverview = ({snapshot}: props) => {
  return (
    <>
        <SearchInPageInput />
        <SectionWrapper>
        <GeneralDetailsTable snapshot={snapshot} />
        </SectionWrapper>
    </>
  );
}

export default SnapshotOverview;